import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

import { useCurrentUser } from '@feature/security';

import { TravelRequest, canManageTravelBoardDecisions } from '../../model/TravelRequestTypes';
import { TravelRequestFileRow } from './TravelRequestFileRow';

interface TravelRequestBoardDecisionFilesProps {
  request: TravelRequest;
}

export function TravelRequestBoardDecisionFiles({ request }: TravelRequestBoardDecisionFilesProps) {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const canManage = canManageTravelBoardDecisions(request, currentUser.currentRole);
  const files = request.files.filter(file => file.kind === 'ADMINISTRATIVE_BOARD_DECISION');

  return (
    <Content type="full">
      <Text fw="500">{t('travel.fileKindEnum.ADMINISTRATIVE_BOARD_DECISION')}</Text>

      {files.length === 0 ? (
        <Text
          size="sm"
          c="dimmed"
          fs="italic"
        >
          {t('travel.requests.view.noFiles')}
        </Text>
      ) : (
        <Stack gap="xs">
          {files.map(requestFile => (
            <TravelRequestFileRow
              key={requestFile.id}
              requestId={request.id}
              requestFile={requestFile}
              activityType={request.activityType}
              canDelete={canManage}
            />
          ))}
        </Stack>
      )}
    </Content>
  );
}
